import { createSlice } from "@reduxjs/toolkit";

export const aiSlice = createSlice({
    name: "ai",
    initialState: {
        completion: "",
        toolCompletion: null,
    },
    reducers: {
        setCompletion: (state, action) => {
            state.completion = action.payload;
        },
        setToolCompletion: (state, action) => {
            state.toolCompletion = action.payload;
        },
    },
});

export const { setCompletion, setToolCompletion } = aiSlice.actions;

export const selectCompletion = (state) => state.ai.completion;
export const selectToolCompletion = (state) => state.ai.toolCompletion;

export default aiSlice.reducer;
